import { Box, FlexLayout } from '@deity-io/portal-ui';
import { RequestExplorerActionTypes, RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext } from 'react';
import { useOnRequestLogLineAddedSubscription } from 'services/graphql/generated/hooks';

const LogConsole: FC = () => {
  // const [state, setState] = useState<{ currentEditor: 'none' | 'raw' | 'json' }>({ currentEditor: 'none' });

  const ctx = useContext(RequestExplorerContext);
  const {
    data: logData,
    loading,
    error
  } = useOnRequestLogLineAddedSubscription({
    variables: { uuid: ctx?.state.sessionUuid || '' },
    skip: ctx?.state.sessionUuid === undefined,
    onSubscriptionData: data => {
      // eslint-disable-next-line no-console
      console.log('got data ', data.subscriptionData.data);

      ctx?.dispatch({
        type: RequestExplorerActionTypes.ADD_LOG_LINE,
        payload: {
          date: data.subscriptionData.data?.requestLogLineAdded.date
            ? new Date(data.subscriptionData.data?.requestLogLineAdded.date)
            : new Date(),
          text: data.subscriptionData.data?.requestLogLineAdded.log || ''
        }
      });
    }
  });
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  // console.log({ data: logData, error, loading });
  return (
    <Box
      style={{
        minHeight: '100px',
        borderStyle: 'solid',
        borderColor: '#D4D4D4',
        borderWidth: '1px',
        padding: '10px',
        margin: '10px'
      }}
    >
      {ctx.state.sessionLog.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <FlexLayout key={`logLine_${index}`} width="full" flexDirection="row" flexWrap="nowrap">
          <Box key="date">{item.date.toLocaleTimeString()}</Box>
          <Box
            style={{
              paddingLeft: '10px'
            }}
            key="text"
          >
            {item.text}
          </Box>
        </FlexLayout>
      ))}
    </Box>
  );
};
export default LogConsole;
